import React from "react";
import {Image} from 'react-bootstrap';
import Header from "../components/Header/Header";
import ProjectCycle from "../components/SuccessCase/ProjectCycle";
import CasePresentaion from "../components/SuccessCase/CasePresentaion";
import CaseBand from "../components/SuccessCase/CaseBand";
import Partner from "../components/Index/Partner";
import Footer from "../components/Footer/Footer";
import BackToTop from "../components/BackToTop/BackToTop";

import './SuccessCase.css'

class SuccessCase extends React.Component {
  render() {
    return (
      <div className="successCase">
        {/* 页头 */}
        <Header pageName="successCase"/>

        {/* 页头图 */}
        <Image src="https://hzby-devops.oss-cn-shanghai.aliyuncs.com/hzby_website/pho_banner_4_edition_2.webp" className="case_bkimg" />

        {/* 项目周期 */}
        <ProjectCycle />

        {/* 案例展示 */}
        <CasePresentaion />

        {/* 中部banner */}
        <CaseBand />

        {/* 合作伙伴 */}
        <Partner />

        {/* 页脚 */}
        <Footer />

        {/* 回到顶部 */}
        <BackToTop />
      </div>
    )
  }
}

export default SuccessCase
